import { render, staticRenderFns } from "./jp.vue?vue&type=template&id=c18b6f1c&scoped=true"
import script from "./jp.vue?vue&type=script&lang=js"
export * from "./jp.vue?vue&type=script&lang=js"
import style0 from "./jp.vue?vue&type=style&index=0&id=c18b6f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18b6f1c",
  null
  
)

export default component.exports